import MuiModal, {ModalProps} from '@mui/material/Modal';

import styles from './Modal.module.scss';

const Modal = (props: ModalProps): JSX.Element => {
  return <MuiModal className={styles.modal} {...props} />;
};

export default Modal;
